window.Popper = require('popper.js');
require('./bootstrap');
window.Swiper = require('swiper/swiper-bundle.min');
require('jquery-fancybox/source/js/jquery.fancybox');
require('air-datepicker/dist/js/datepicker.min');
require('air-datepicker/dist/js/i18n/datepicker.en');


AOS.init();
